import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FormHelper } from '@helpers/form.helper';
import { ShipmentModel } from '@data-layer/models/common';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { CompanyModel } from '@data-layer/models/companies';
import { EsShipmentDetailsFormDesktopComponent } from '../es-shipment-details-form-desktop/es-shipment-details-form-desktop.component';

@Component({
  selector: 'es-bonds-form-desktop',
  template: `
    <es-shipment-details-form-desktop
      [entrySummary]="entrySummary"
      [company]="company"
      [formGroup]="formGroup"
      [isSidebar]="true"
      [forceEditable]="forceEditable"
      [isManagement]="isManagement"
    ></es-shipment-details-form-desktop>

    <div class="sidebar-form-buttons" (click)="saveData()">
      <button type="button" class="btn btn-primary">{{ 'BUTTON.SAVE' | translate }}</button>
    </div>
  `,
  styleUrls: ['./es-bonds-desktop.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsBondsDesktopComponent implements OnInit {
  @Input() public entrySummary: EntrySummaryModel;
  @Input() public company: CompanyModel;
  // Additive (broker review): force editability on state 50 + management mode (SEB-only bonds). #13102.
  @Input() public forceEditable: boolean = false;
  @Input() public isManagement: boolean = false;
  @Output() public dataSaved: EventEmitter<ShipmentModel> = new EventEmitter<ShipmentModel>();

  @ViewChild(EsShipmentDetailsFormDesktopComponent, { static: false })
  public esShipmentDetailsFormDesktopComponent: EsShipmentDetailsFormDesktopComponent;

  public formGroup: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private fh: FormHelper) {}

  public ngOnInit(): void {
    this.formGroup = this.fh.createEntryShipmentFormGroup(this.company?.authorizationAgreementAccepted && !!this.company?.payerUnitNumber);
    this.formGroup.patchValue(this.entrySummary);
  }

  public saveData() {
    this.esShipmentDetailsFormDesktopComponent.onSubmit();
    this.dataSaved.emit(this.formGroup.value);
  }
}
